import React, { FC } from 'react';
import { Image } from 'antd-mobile';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { jumpToUrl } from '@/utils';
import css from './index.module.less';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

interface BannerItem {
  bannerUrl?: string;
  jumpUrl?: string;
  state?: number;
}

interface BannerSwiperProps {
  fallbackImage?: string; // 兜底图片
  list?: BannerItem[];
  pcList?: BannerItem[]; // PC端轮播图列表
  className?: string;
}

const BannerSwiper: FC<BannerSwiperProps> = ({
  className = '',
  fallbackImage,
  list,
  pcList,
}) => {
  const navigate = useNavigate();

  // 判断是否为PC端
  const [isPC, setIsPC] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 768px)');

    // 设置初始值
    setIsPC(mediaQuery.matches);

    // 监听媒体查询变化
    const handleChange = (e: MediaQueryListEvent) => {
      setIsPC(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // 根据PC端/移动端选择轮播图列表
  // PC端：优先 pcList，无数据则显示 fallbackImage（不降级到 list）
  // 移动端：list → fallbackImage
  const bannerList = isPC ? pcList : list;
  // 点击轮播图处理
  const handleBannerClick = (banner: BannerItem) => {
    (window as any)?._hmt?.push([
      '_trackEvent',
      'banner',
      'click',
      banner?.jumpUrl,
    ]);
    if (banner.jumpUrl) {
      // jumpToUrl(banner.jumpUrl)
      navigate(`/image-show?image=${banner.jumpUrl}`);
    }
  };

  return (
    <div
      className={`${css.bannerContainer} ${
        isPC ? css.pcMode : ''
      } ${className}`}
    >
      {bannerList?.length > 0 ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            bulletClass: css.swiperBullet,
            bulletActiveClass: css.swiperBulletActive,
          }}
          loop={bannerList.length > 1}
          className={css.bannerSwiper}
        >
          {bannerList.map((banner, index) => (
            <SwiperSlide key={index}>
              <div
                className={css.bannerSlide}
                onClick={() => handleBannerClick(banner)}
              >
                <Image
                  src={banner.bannerUrl}
                  alt={`${index + 1}`}
                  className={css.bannerImage}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : fallbackImage ? (
        <div className={css.fallbackContainer}>
          <img src={fallbackImage} alt='' className={css.fallbackImage} />
        </div>
      ) : null}
    </div>
  );
};

export default BannerSwiper;
